import React from 'react';
import { AlarmClockIcon, AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../../hooks/useCountdown';
import { launchOffer } from '../../data/salesContent';
export function CountdownSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(launchOffer.hours);
  const units = [{
    value: hours,
    label: 'HS'
  }, {
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEG'
  }];
  return <section className="bg-ink px-5 py-20 md:py-24" aria-label="Precio de lanzamiento" data-id="element-85" data-mp="14ohol4yagxc4">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-gold bg-ink-soft p-7 text-center md:p-12" data-id="element-86" data-mp="19hkhrbz5m4rs">
        <p className="flex items-center justify-center gap-2 font-display text-base font-extrabold uppercase tracking-wide text-gold md:text-xl" data-id="element-87" data-mp="vqxldqgv8qyv">
          <AlarmClockIcon className="h-5 w-5 shrink-0 md:h-6 md:w-6" aria-hidden="true" data-id="element-88" data-mp="lrgh9dh9il50" />
          Precio de lanzamiento — cierra en:
        </p>

        <div className="mt-8 flex items-start justify-center gap-2 md:gap-4" role="timer" aria-live="off" data-id="element-89" data-mp="qprqblzqgrm6">
          {units.map((u, i) => <React.Fragment key={u.label} data-id="element-90" data-mp="1c7lamj8h9ctt" data-mpi={i}>
              <div className="flex w-20 flex-col items-center rounded-2xl border border-gold/30 bg-ink py-4 md:w-28 md:py-5" data-id="element-91" data-mp="1c6tdh3z8f71f">
                <span className="font-display text-4xl font-black tabular-nums leading-none text-cream md:text-6xl" data-id="element-92" data-mp="1q59w9tadcnzx">
                  {String(u.value).padStart(2, '0')}
                </span>
                <span className="mt-2 text-xs font-bold tracking-widest text-gold md:text-sm" data-id="element-93" data-mp="ygg550ifhqbk">{u.label}</span>
              </div>
              {i < units.length - 1 && <span className="pt-3 font-display text-4xl font-black text-gold md:pt-4 md:text-5xl" aria-hidden="true" data-id="element-94" data-mp="179jpztvel5g8">
                  :
                </span>}
            </React.Fragment>)}
        </div>

        <p className="mt-8 flex items-center justify-center gap-2 text-base font-semibold text-cream md:text-lg" data-id="element-95" data-mp="eq4gbnl88syd">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-yellow-300" aria-hidden="true" data-id="element-96" data-mp="aosvrwh7mxx1" />
          Después sube {launchOffer.priceIncrease}. No vuelve.
        </p>

        <div className="mx-auto mt-8 max-w-md text-left" data-id="element-97" data-mp="2esvs0ndlg1wm">
          <div className="flex items-center justify-between gap-3 text-sm font-semibold md:text-base" data-id="element-98" data-mp="2jknfgp1gdrij">
            <span className="flex items-center gap-2 text-cream" data-id="element-99" data-mp="2okjiakyezcwi">
              <span className="h-2.5 w-2.5 rounded-full bg-red-500" aria-hidden="true" data-id="element-100" data-mp="1qwj53q7xsq9i" />
              Cupos al precio de lanzamiento
            </span>
            <span className="text-red-400" data-id="element-101" data-mp="1vwdx5x3g7lw5">Quedan pocos</span>
          </div>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-ink-line" role="progressbar" aria-valuenow={launchOffer.spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} data-id="element-102" data-mp="20ufot6exwtj8">
            <div className="h-full rounded-full bg-gold" style={{
            width: `${launchOffer.spotsTakenPercent}%`
          }} data-id="element-103" data-mp="3cbymykdny6ax" />
          </div>
          <p className="mt-3 text-center text-sm text-neutral-400 md:text-base" data-id="element-104" data-mp="15lc4501rjec1">
            <span className="font-bold text-gold" data-id="element-105" data-mp="10miph4aqphaa">{launchOffer.spotsTakenPercent}%</span> de los cupos al precio de lanzamiento ya tomados.
          </p>
        </div>
      </div>
    </section>;
}